import {
    SEARCH_MODE_DEFAULT,
    SEARCH_MODE_MANUAL_LIST,
} from './constants.js';

export function createGlobalSearchState(defaultTitle) {
    let searchSequence = 0;
    let debounceHandle = null;
    let activeMode = SEARCH_MODE_DEFAULT;
    let manualListId = '';
    let manualListToggleUrl = '';
    let manualListPendingToggleIds = new Set();
    let manualListToggleCooldownUntil = new Map();
    let manualListChanged = false;
    let manualListSurfaceSynced = false;

    const resetMode = () => {
        activeMode = SEARCH_MODE_DEFAULT;
        manualListId = '';
        manualListToggleUrl = '';
        manualListPendingToggleIds = new Set();
        manualListToggleCooldownUntil = new Map();
        manualListChanged = false;
        manualListSurfaceSynced = false;
    };

    const configureModeFromTrigger = (trigger) => {
        resetMode();

        if (!(trigger instanceof HTMLElement)) {
            return;
        }

        const mode = String(trigger.dataset.globalSearchMode ?? '').trim();
        if (mode !== SEARCH_MODE_MANUAL_LIST) {
            return;
        }

        const toggleUrl = String(trigger.dataset.globalSearchToggleUrl ?? '').trim();
        if (toggleUrl === '') {
            return;
        }

        activeMode = SEARCH_MODE_MANUAL_LIST;
        manualListId = String(trigger.dataset.globalSearchListId ?? '').trim();
        manualListToggleUrl = toggleUrl;
    };

    return {
        getDefaultTitle: () => defaultTitle,

        nextSearchSequence: () => {
            searchSequence += 1;

            return searchSequence;
        },
        getSearchSequence: () => searchSequence,

        setDebounceHandle: (nextHandle) => {
            debounceHandle = nextHandle;
        },
        getDebounceHandle: () => debounceHandle,

        resetMode,
        configureModeFromTrigger,

        isManualListMode: () => activeMode === SEARCH_MODE_MANUAL_LIST,
        getManualListId: () => manualListId,
        getManualListToggleUrl: () => manualListToggleUrl,
        markManualListChanged: () => {
            manualListChanged = true;
            manualListSurfaceSynced = false;
        },
        markManualListSurfaceSynced: () => {
            manualListSurfaceSynced = true;
        },
        shouldFallbackReloadAfterManualListChange: () => activeMode === SEARCH_MODE_MANUAL_LIST && manualListChanged && !manualListSurfaceSynced,

        isTogglePending: (gameId) => manualListPendingToggleIds.has(gameId),
        addPendingToggle: (gameId) => {
            manualListPendingToggleIds.add(gameId);
        },
        removePendingToggle: (gameId) => {
            manualListPendingToggleIds.delete(gameId);
        },
        isToggleCoolingDown: (gameId) => {
            const cooldownUntil = manualListToggleCooldownUntil.get(gameId);
            return typeof cooldownUntil === 'number' && cooldownUntil > Date.now();
        },
        setToggleCooldown: (gameId, durationMs) => {
            manualListToggleCooldownUntil.set(gameId, Date.now() + Math.max(0, durationMs));
        },
    };
}
